import { Env } from '@didi/utils'
import { noop, compare, getContent } from '../util/tool'
import { wechatReady } from '../core/wechat'
import { alipayReady } from '../core/alipay'
import { mqqReady } from '../core/mqq'
import commonLangZh from '../lang/zh-CN/common'
import commonLangEn from '../lang/en-US/common'
import codeLangZh from '../lang/zh-CN/get-code'
import codeLangEn from '../lang/en-US/get-code'

const mqqAppid = '101188284'
const allContent = {
  'zh-CN': {
    ...commonLangZh,
    ...codeLangZh
  },
  'en-US': {
    ...commonLangEn,
    ...codeLangEn
  }
}
let lang
let mqqBuilded = false

export function getCode(...args) {
  let options = {}
  let callback = noop
  if (args.length === 1) {
    callback = args[0]
  } else {
    options = args[0]
    callback = args[1]
  }
   /* istanbul ignore else */
  if (options.lang) {
    lang = options.lang
  }
  if (Env.isWechat) {
    wechatGetCode(callback)
  } else if (Env.isAlipay) {
    aliPayGetCode(callback)
  } else if (Env.isMqq) {
    mqqGetCode(options, callback)
  } else {
    callback(new Error(getContent(allContent, 'envFail', lang)))
  }
}
function wechatGetCode(callback) {
  if ((Env.isIOS && compare(Env.wechatVersion, '>', '6.5.1')) || (Env.isAndroid && compare(Env.wechatVersion, '>', '6.5.5'))) {
      wechatReady((err, wx) => {
        if (!err) {
          wx.invoke('login', {}, function (res) {
            if (res.code) {
              callback(null, res.code)
            } else {
              callback(new Error(getContent(allContent, 'wechatFail', lang)))
            }
          })
        } else {
          callback(err)
        }
      })
    } else {
      callback(new Error(getContent(allContent, 'versionFail', lang)))
    }
    return
}

function aliPayGetCode(callback) {
  if (compare(Env.alipayVersion, '>', '10.0.0')) {
      alipayReady((err, bridge) => {
        if (compare(bridge.startupParams.version, '>=', '1.0.0.14') && bridge.startupParams.appId === '20000778') {
          bridge.call('getAuthCode', {
            scopeNicks: ['auth_base']
          }, function (res) {
            if (res && res.authcode) {
              callback(null, res.authcode)
            } else {
              callback(err)
            }
          })
        } else {
          callback(new Error(getContent(allContent, 'alipayParamsFail', lang)))
        }
      })
    } else {
      callback(new Error(getContent(allContent, 'versionFail', lang)))
    }
    /* istanbul ignore next */
    return
}

function mqqGetCode(options, callback) {
  const appid = options.appid || mqqAppid
    if (compare(Env.mqqVersion, '<', '6.5.0')) {
      callback(new Error(getContent(allContent, 'versionFail', lang)))
      return
    }
    mqqReady((err, mqq) => {
      if (err) {
        callback(err)
        return
      }
      if (!mqqBuilded) {
        mqq.build('mqq.tenpay.getAppAuthorizationCode', {
          iOS: function(params, callback) {
            mqq.invokeClient('qw_charge', 'getAppAuthorizationCode', params, callback)
          },
          android: function(params, callback) {
            params.callback = mqq.callback(callback)
            mqq.invokeClient('qw_charge', 'getAppAuthorizationCode', params)
          },
          supportInvoke: true,
          support: {
             iOS: '6.5.0',
             android: '6.5.0'
          }
        })
        mqqBuilded = true
      }
      function getAuthCode() {
        return new Promise((resolve, reject) => {
          mqq.tenpay.getAppAuthorizationCode(
            {
              appid
            },
            function(res) {
              if (res && res.code) {
                resolve(res.code)
              } else {
                reject()
              }
          })
        })
      }
      Promise.race([getAuthCode(), timeout()]).then((code) => {
        callback(null, code)
      }).catch(() => {
        callback(new Error(getContent(allContent, 'envFail', lang)))
      })
    })
    return
}
function timeout(delay = 3000) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      reject()
    }, delay)
  })
}
export default getCode

